import useGetApi from 'src/api/useGetApi';
import {
  QuoteSheetDashboardFilters,
  QuoteSheetDashboardResponse,
} from './quote-sheets-types';

export function useQuoteSheetDashboard(filters?: QuoteSheetDashboardFilters) {
  // Convert filters to query parameters
  const queryParameters: Record<string, string | boolean> = {};

  if (filters?.supplierId) {
    queryParameters.supplierId = filters.supplierId;
  }
  if (filters?.productId) {
    queryParameters.productId = filters.productId;
  }
  if (filters?.productVariantId) {
    queryParameters.productVariantId = filters.productVariantId;
  }
  if (filters?.dateFrom) {
    queryParameters.dateFrom = filters.dateFrom.toISOString();
  }
  if (filters?.dateTo) {
    queryParameters.dateTo = filters.dateTo.toISOString();
  }
  if (filters?.search) {
    queryParameters.search = filters.search;
  }
  if (filters?.productMatch) {
    queryParameters.productMatch = filters.productMatch;
  }

  return useGetApi<QuoteSheetDashboardResponse>({
    endpoint: 'accounts-payable/quote-sheet-items',
    queryParameters,
    options: {
      enabled: true, // Always enabled since we have default date behavior on backend
    },
  });
}
